import { trackShowToSUpdatePopupAsyncSuccess, trackShowToSUpdatePopupAsync } from "./analytics/events.mjs";
import { createError } from "./errorUtils.mjs";
import globalTime from "./globalTime.mjs";
class TermsOfService {
  constructor(platform) {
    this.platform = platform;
  }
  /**
   * @returns A promise that resolves to `true` in case of a new user or if existing user has already accepted the ToS update.
   * The promise resolves immediately if platform storage is ready to use.
   * In case of Replicant-backed platform storage, platform storage is ready to use after creating the Replicant client.
   */
  async hasAcceptedToS(tosVersion) {
    var _a;
    this.tryValidateTosVersion(tosVersion);
    await this.platform.loadStorage();
    return !!((_a = this.platform.storage.tos[tosVersion]) == null ? void 0 : _a.acceptedAt);
  }
  /** Accept the ToS update. Call this method after the user accepts the ToS update. */
  acceptToS(tosVersion, analyticsData) {
    this.tryValidateTosVersion(tosVersion);
    trackShowToSUpdatePopupAsyncSuccess({
      requestMs: analyticsData.requestMs,
      ToSVersion: tosVersion
    });
    this.platform.storage.assign(
      (storage) => storage.tos[tosVersion] = { acceptedAt: globalTime.getNow() }
    );
  }
  /** Track the `ShowToSUpdatePopupAsync` analytics event. Call this method right before displaying the ToS update prompt. */
  trackPopupOpenEvent(tosVersion) {
    this.tryValidateTosVersion(tosVersion);
    trackShowToSUpdatePopupAsync({ ToSVersion: tosVersion });
  }
  tryValidateTosVersion(tosVersion) {
    const validToSVersions = ["2022-12"];
    if (!validToSVersions.includes(tosVersion)) {
      throw createError("INVALID_PARAM", "Invalid ToS version: " + tosVersion);
    }
  }
}
export {
  TermsOfService
};
